export default "__VITE_ASSET__CqZ6ZXQl__"